module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 1024 1024\"><path d=\"M945 305l78 67-510 524L3 372l75-69 435 451 432-449z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/ChevronIcon/ChevronIcon.svg
 ** module id = 628
 ** module chunks = 0
 **/